/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useCallback, useEffect, useRef, useState } from 'react'
import CardHeader from '../../../components/CardHeader'
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import { PayslipList } from './PayslipSlice';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../components/Pagination';
import Table from './Componets/Table';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';

export default function Payslips() {
    const FilterRef = useRef(null);
    const [fyList, setFYList] = useState([])
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams({financial_year : JSON.parse(localStorage.getItem('FY_details'))?.name, page_number: 1});
    const [loading, setLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const PaySlipList = useSelector(state => state.PayslipListSlice);
    const { List} = PaySlipList
    const [openFilter, setOpenFilter] = useState(false)

    const getFY = useCallback(async () => {
        const branch_id = await GetBranchId();
        try {
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing`);
            setFYList(res?.data?.data?.financial_years)

        } catch (error) {
            // Handle the error here
            console.error('An error occurred:', error);
        }
    }, []);
        /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({financial_year : JSON.parse(localStorage.getItem('FY_details')).name, page_number:  1 })
    }

    /* The `getPayslipData` function is an asynchronous function that is used to fetch payslip data
    from the server. */
    const getPayslipData = useCallback(async () => {
        setEmptyScreenMessage("");
        setLoading(true);
        try {
            const branch_id = await GetBranchId()
            const user = await CognitoData();
            dispatch(PayslipList(`payroll/list-payslips?branch_id=${branch_id}&employee_number=${user.idToken.payload["custom:employee_number"]}&limit=10&filter=true&${searchParams.toString()}`)).then((response) => {
                // if (response?.payload?.data.status===200) {
             
                //     if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                //         if(response?.payload?.data?.data.total_count !== 0) {
                //             // setToastErrorMessage('Something went wrong. Please try again')
                //             setEmptyScreenMessage("No data found");
                //         } else {
                //             setEmptyScreenMessage("No matching records found.")
                //         }
                //         setLoading(false);
                //     } else {
                //         setLoading(false);
                //     }
                // } else {
                //     setLoading(false);
                //     setEmptyScreenMessage("No data found");
                //     // setToastErrorMessage('Something went wrong. Please try again')
                // }
                setLoading(false);
            })
        } catch (error) {
            setEmptyScreenMessage("No data found");
            setLoading(false);
            handleLoadData()
        }
    }, [searchParams]);

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is being used to call the `getFY` and `getPayslipData` functions when the
    component mounts or when the `getPayslipData` function changes. */
    useEffect(() => {
        getFY()
        getPayslipData()
    }, [getPayslipData])

    /**
     * The function `handleSearchParams` updates the search parameters, sets loading to true, and
     * closes the filter.
     */
    const handleSearchParams = (key, value) => {
        setLoading(true);
        if (searchParams.get("financial_year") !== value) {
            let params = Object.fromEntries(searchParams);
            params.page_number = 1
            params[key] = value
            setSearchParams({ ...params})
        } else {
            setTimeout(() => {
                setLoading(false);
            }, [600]);
        }
        setOpenFilter(false);
    }

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the `FilterRef` element, which is
    a reference to the filter dropdown. When a click is detected outside of the `FilterRef` element,
    the callback function `()=>{ setOpenFilter(false) }` is executed, which closes the filter
    dropdown by setting the `openFilter` state to `false`. */
    useOnClickOutside(FilterRef,()=>{
        setOpenFilter(false)
    })
      
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    return (
        <CardHeader noPadding>
            <div className={`mainDataCntnrTop shadow-s13`}>
                <div class="flex items-center">
                    <h5 className="pageHeader">
                        Payslips
                    </h5>
                </div>
                <div class="flex items-center">
                    <div className="relative w-[237px] ml-10" ref={FilterRef}>
                        <button
                            onClick={() => setOpenFilter(!openFilter)}
                            className={`sec_filter_btn`}
                            type="button"
                            id="month_filter"
                            title={fyList.find((item) => item.name === searchParams.get("financial_year"))
                                ? `${fyList.find((item) => item.name === searchParams.get("financial_year")).name} (${formatAdjustedDate(fyList.find((item) => item.name === searchParams.get("financial_year")).start_date)} - ${formatAdjustedDate(fyList.find((item) => item.name === searchParams.get("financial_year")).end_date)}) (${fyList.find((item) => item.name === searchParams.get("financial_year")).status.charAt(0).toUpperCase() + fyList.find((item) => item.name === searchParams.get("financial_year")).status.slice(1)})`
                                : "Select Financial Year"}
                        >
                            <p className="text-f7 text-[#000000] font-normal">
                                {fyList.find((item) => item.name === searchParams.get("financial_year"))
                                    ? `${fyList.find((item) => item.name === searchParams.get("financial_year")).name} (${fyList.find((item) => item.name === searchParams.get("financial_year")).status.charAt(0).toUpperCase() + fyList.find((item) => item.name === searchParams.get("financial_year")).status.slice(1)})`
                                    : "Select Financial Year"}
                            </p>
                            <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-2 ${openFilter ? "transform rotate-180" : ""}`} />
                        </button>

                        {openFilter && <ul className="slct_drp_dwn min-w-full min-w-full [&amp;[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref="" style={{ 'margin': '0 7px' }}>
                            <li className="max-h-[150px] overflow-auto scroll-bar">
                                <ul>
                                    {fyList?.map((item, i) => (
                                        <li key={item._id}>
                                            <p
                                                onClick={() => {handleSearchParams("financial_year", item.name)}}
                                                id={i + 'fy'}
                                                title={`${item.name} (${formatAdjustedDate(item.start_date)} - ${formatAdjustedDate(item.end_date)}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                                                className="slct_drp_dwn_optn selected_Class"
                                            >
                                                {`${item.name} (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                                            </p>
                                        </li>))}
                                </ul>
                            </li>
                        </ul>}
                    </div>
                </div>
            </div>
            <div className='mainDataCntnrListDiv scrollBlue_thick'>

                {(loading) ? <ItemShimmer />
                    : <>
                        <Table
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickSort={handleSearchParams}
                            sortValue={searchParams.get('sort') || ''}
                            searchParams={searchParams}
                            setLoading={setLoading}
                        />
                        {(List?.total_count > 10) && <Pagination
                            TotalCount={List.total_count}
                            totalPageNumber={Math.ceil(List.total_count / 10)}
                            selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                        />}
                    </>      
                }
            </div>

        </CardHeader>
    )
}
